import { IMetadata } from '../metadata/Metadata';
import { ExtractedContextualValue } from './ContextualValue';
import { isContextualValueEmpty } from './isContextualValueEmpty';

export function isContextualValueEditable(metadata: IMetadata) {
  return metadata.contextualEditable;
}
